import React from 'react';
import { browserHistory } from 'react-router';

import './styles.css'

import { ButtonSimple } from "../../Elements/Buttons";
import {clientMedia} from "../../../Config/Settings";

const SideBar = () => {
    return (
        <div className="side-bar-wrapper">
            <aside>
                <section className="side-bar-header">
                    <img src={`${clientMedia()}/img/logos/title-logo.png`} alt="logo"/>
                    <span>Admin Panel</span>
                </section>
                <section className="nav">
                    <nav>
                        <ul>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/users')}} label="Users"/></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-events')}} label="Live Music Events" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-services')}} label="Music Services" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-musicians')}} label="Musicians" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-bands')}} label="Bands" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-categories')}} label="Categories" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/packages')}} label="Packages" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/banner-selection')}} label="Banner" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/transactions')}} label="Transactions" /></li>
                            <li><ButtonSimple onPress={() => {browserHistory.push('/olimpus/music-settings')}} label="Settings" /></li>
                        </ul>
                    </nav>
                </section>
            </aside>
        </div>
    )
};

SideBar.propTypes = {

};

export default SideBar;



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/SideBar/SideBar.js